<template>
  <Modal
    v-if="showContent"
    :config="modalConfig.forceLogout"
    @btn2Action="loginAgain"
  >
  </Modal>
</template>

<script>
export default {
  name: 'ForceLogout',
  components: {
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      showContent: true,
      modalConfig: {
        forceLogout: {
          enabled: true,
          title: this.$t('forceLogout.title'),
          persistent: true,
          subtitle: this.$t('forceLogout.content'),
          btn2Label: this.$t('forceLogout.forceLogoutBtn'),
          width: 500
        }
      }
    }
  },
  methods: {
    loginAgain () {
      this.$logoutSetting.methods.systemLogout()
    }
  }
}
</script>
